import * as React from 'react';

interface SvgAssetGetLinkProps extends React.SVGProps<SVGSVGElement> {
  loading?: boolean;
}

function SvgAssetGetLink({ loading = false, ...props }: SvgAssetGetLinkProps) {
  if (loading) {
     return (
      <svg
        width="1.03em"
        height="1.03em"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        {...props}
      >
        <circle
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
          strokeDasharray="60"
          strokeDashoffset="20"
          strokeLinecap="round"
        >
          <animateTransform
            attributeName="transform"
            type="rotate"
            dur="1s"
            from="0 12 12"
            to="360 12 12"
            repeatCount="indefinite"
          />
        </circle>
      </svg>
    );
  }
  return (
    <svg
      width="1.03em"
      height="1.03em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      focusable={false}
      {...props}
    >
      <path
        d="m13.7533481 2c1.1572504 0 2.1101399.8749731 2.233208 1.9994587l1.7634439.0005413c1.190864 0 2.1656449.92516159 2.2448092 2.09595119l.0051908.15404881v6c0 .4142136-.3357864.75-.75.75-.3796958 0-.693491-.2821539-.7431534-.6482294l-.0068466-.1017706v-6c0-.37969577-.2821539-.69349096-.6482294-.74315338l-.1017706-.00684662-2.1317095-.00016437c-.4034815.59926471-1.0881764.9934682-1.8649424.9934682h-3.5066962c-.77676603 0-1.46146092-.39420349-1.86494238-.9934682l-2.13170952.00016437c-.37969577 0-.69349096.28215388-.74315338.64822944l-.00684662.10177056v13.504591c0 .3796958.28215388.693491.64822944.7431534l.20354112.0136932c.36607556.0496624.64822944.3634576.64822944.7431534 0 .4142136-.33578644.75-.75.75-1.19086399 0-2.16564492-.9251616-2.24480919-2.0959512l-.00519081-.1540488v-13.504591c0-1.19086399.92516159-2.16564492 2.09595119-2.24480919l.15404881-.00519081 1.76344395-.0005413c.12306801-1.1244856 1.07595753-1.9994587 2.23320795-1.9994587zm3.4966519 12.5h1c2.0710678 0 3.7499918 1.6789322 3.7499918 3.75 0 2.0042592-1.5723529 3.6412737-3.5477126 3.744802l-.198836.005198-1 .0045992c-.4142092.0018855-.7515337-.3323558-.7534514-.746565-.0017277-.3796918.2789832-.694779.6448269-.7461215l.1017381-.0073138 1.0034432-.0045989c1.2426407 0 2.2499918-1.0073593 2.2499918-2.25 0-1.190864-.9251534-2.1656449-2.095943-2.2448092l-.1540488-.0051908h-1c-.4142136 0-.7500082-.3357864-.7500082-.75 0-.3796958.2821621-.693491.6482376-.7431534l.1017706-.0068466h1zm-5 0h1c.4142136 0 .75.3357864.75.75 0 .3796958-.2821539.693491-.6482294.7431534l-.1017706.0068466h-1c-1.2426407 0-2.25 1.0073593-2.25 2.25 0 1.190864.9251616 2.1656449 2.0959512 2.2448092l.1540488.0051908h1c.4142136 0 .75.3357864.75.75 0 .3796958-.2821539.693491-.6482294.7431534l-.1017706.0068466h-1c-2.0710678 0-3.75-1.6789322-3.75-3.75 0-2.0042592 1.5723611-3.6412737 3.5508414-3.744802l.1991586-.005198h1zm0 3h6c.4142136 0 .75.3357864.75.75 0 .3796958-.2821539.693491-.6482294.7431534l-.1017706.0068466h-6c-.4142136 0-.75-.3357864-.75-.75 0-.3796958.2821539-.693491.6482294-.7431534l.1017706-.0068466h6zm1.5033481-14h-3.5066962c-.41236445 0-.7466519.33428745-.7466519.74665191 0 .41236447.33428745.74665192.7466519.74665192h3.5066962c.4123645 0 .7466519-.33428745.7466519-.74665192 0-.41236446-.3342874-.74665191-.7466519-.74665191z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgAssetGetLink;